import { render } from "./MobileBar.vue?vue&type=template&id=20ce447e&scoped=true&ts=true"
import script from "./MobileBar.vue?vue&type=script&lang=ts"
export * from "./MobileBar.vue?vue&type=script&lang=ts"

import "./MobileBar.vue?vue&type=style&index=0&id=20ce447e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ce447e"]])

export default __exports__